import { Component } from '@angular/core';
import {NzAlertComponent} from 'ng-zorro-antd/alert';

@Component({
    selector: 'app-unauthorized',
    imports: [
        NzAlertComponent
    ],
    template: `
    <div style="padding: 50px;">
      <nz-alert nzMessage="Unauthorized access attempted" nzType="error"></nz-alert>
    </div>
  `,
    styles: ``
})
export class UnauthorizedComponent {

}
